import script from "./Settings.vue?vue&type=script&setup=true&lang=js"
export * from "./Settings.vue?vue&type=script&setup=true&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=a5c10304&scoped=true&lang=css"
import "./Settings.vue?vue&type=style&index=1&id=a5c10304&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c10304"]])

export default __exports__